import { useCallback } from 'react'
import { BaseButtonModalSortListProps } from '../../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { twinFetchPostText } from '../../../../../../../utils/globals/data'

interface ConfigBillingTypeBuySortButtonProps extends BaseButtonModalSortListProps {
}

const ConfigBillingTypeBuySortButton: React.FC<ConfigBillingTypeBuySortButtonProps> = ({ ...rest }) => {
    const { updateOrder } = useConfigBillingTypeBuySortButtonLogic()
    return (
        <ButtonModalSortList updateData={updateOrder} getDataFrom='/api/app/config/billingGroup/billingTypeBuy/getAllBillingTypesBuy' {...rest} />
    )
}

const useConfigBillingTypeBuySortButtonLogic = () => {
    const updateOrder: ItemSortFunction = useCallback(async (data) => {
        const resp = await twinFetchPostText('/api/app/config/billingGroup/billingTypeBuy/updateBillingTypesBuyOrder', { billingTypesBuy: data })
        if (resp) {
            return true
        }
        return false
    }, [])

    return { updateOrder }
}

export default ConfigBillingTypeBuySortButton